package com.nonopn.skydome.common.app.pages.certificates

import com.nonopn.dispatchers.DefaultDispatcher
import com.nonopn.skydome.common.app.api.impl.ApiInterface
import com.nonopn.skydome.common.app.pages.main.model.LoadStrikeRadarData
import com.nonopn.skydome.common.app.pages.main.model.api.Project
import com.nonopn.skydome.common.app.pages.main.model.api.ThunderDetectionActivity
import com.nonopn.skywatcher.common.api.ApiSession
import com.nonopn.skywatcher.design.widgets.abslists.AbstractSectionListModel
import com.nonopn.skywatcher.design.widgets.abslists.AbstractSectionListModelState
import com.nonopn.skywatcher.design.widgets.abslists.ListModelState
import com.nonopn.skywatcher.design.widgets.abslists.Section
import com.nonopn.skywatcher.design.widgets.abslists.SectionListModelStateHolder
import com.nonopn.skywatcher.design.widgets.endOfDay
import com.nonopn.skywatcher.design.widgets.startOfDay
import com.nonopn.skywatcher.maps.ProbabilityHolder
import eu.codlab.viewmodel.launch
import korlibs.time.DateTime
import korlibs.time.DateTimeTz
import korlibs.time.hours
import korlibs.time.minutes
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.FlowPreview
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.async
import kotlinx.serialization.Serializable
import ovh.plrapps.mapcompose.api.ExperimentalClusteringApi

data class CertificatesModelState(
    val loading: Boolean = false,
    val initialized: Boolean = false,
    val apiSession: ApiSession? = null,
    val selectedDate: DateTimeTz,
    val selectedDateFullDay: Boolean = true,
    override val modelState: SectionListModelStateHolder<
            Project,
            ThunderDetectionActivityWithIncidence
            > = SectionListModelStateHolder()
) : AbstractSectionListModelState<Project, ThunderDetectionActivityWithIncidence>

@OptIn(FlowPreview::class)
class CertificatesModel(
    private var currentInterface: ApiInterface
) : AbstractSectionListModel<CertificatesModelState, Project, ThunderDetectionActivityWithIncidence>(
    CertificatesModelState(
        selectedDate = DateTime.now().local.endOfDay
    )
) {
    init {
        safeLaunch {
            updateState {
                copy(
                    initialized = true
                )
            }

            load()

            /*safeLaunch {
                clock.start(2.kotlinMinutes).collect {
                    //TODO check depending on the current interval -> "live" vs non live
                    startLoadingLightning()
                }
            }*/
        }
    }

    override fun onCleared() {
        println("CLEARED MainScreenModel")

        super.onCleared()
    }

    fun setSelectedDate(date: DateTimeTz) {
        updateState {
            copy(selectedDate = date.endOfDay)
        }

        startLoadingLightning(date, states.value.selectedDateFullDay)
    }

    fun setSelectedFullDay(fullDay: Boolean) {
        updateState { copy(selectedDateFullDay = fullDay) }

        startLoadingLightning(states.value.selectedDate, fullDay)
    }

    fun previousSelectedDate() {
        changeSelectedDate(states.value.selectedDate - 30.minutes)
    }

    fun previousSelectedDateDay() {
        changeSelectedDate((states.value.selectedDate.startOfDay - 12.hours).endOfDay)
    }

    fun nextSelectedDate() {
        changeSelectedDate(states.value.selectedDate + 30.minutes)
    }

    fun nextSelectedDateDay() {
        changeSelectedDate((states.value.selectedDate.endOfDay + 12.hours).endOfDay)
    }

    private fun changeSelectedDate(date: DateTimeTz) {
        date.let {
            launch {
                updateState {
                    copy(selectedDate = it)
                }
            }

            startLoadingLightning(it, states.value.selectedDateFullDay)
        }
    }

    private val loadStrikeRadarData = LoadStrikeRadarData(currentInterface)
    private val scope = CoroutineScope(DefaultDispatcher + SupervisorJob())

    @OptIn(ExperimentalClusteringApi::class)
    private fun startLoadingLightning(date: DateTimeTz, fullDay: Boolean) = safeLaunch {
        scope.async {
            updateState {
                copy(
                    loading = true,
                    modelState = modelState.copy(state = ListModelState.LOADING)
                )
            }

            val result = try {
                loadStrikeRadarData.startLoadingLightningForCertificates(date, fullDay, true)
            } catch (_: LoadStrikeRadarData.LoadStrikeRadarCanceledException) {
                // nothing
                return@async
            } catch (_: Throwable) {
                updateState {
                    copy(
                        loading = false,
                        modelState = modelState.copy(state = ListModelState.ERROR)
                    )
                }
                return@async
            }

            val sections = result.map {
                Section(
                    it.project,
                    it.activities
                )
            }

            println("having result ${result.size} size")
            println("having results -> ${result.filter { it.activities.isNotEmpty() }.size}")

            updateState {
                copy(
                    loading = false,
                    modelState = modelState.copy(
                        state = ListModelState.LOADED,
                        objects = sections,
                        filtered = sections.filter { it.entities.isNotEmpty() }
                    )
                )
            }
        }
    }

    override fun load() {
        startLoadingLightning(states.value.selectedDate, states.value.selectedDateFullDay)
    }

    override fun filter(
        section: Section<Project, ThunderDetectionActivityWithIncidence>,
        filteringString: String
    ) = section

    override fun onNewStateHolder(newHolder: SectionListModelStateHolder<Project, ThunderDetectionActivityWithIncidence>) {
        updateState {
            copy(modelState = newHolder)
        }
    }
}

@Serializable
data class ThunderDetectionActivityWithIncidence(
    val activity: ThunderDetectionActivity,
    val probability: ProbabilityHolder
)
